"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconAudiobookAuthor = Experimental__IconAudiobookAuthor;
exports.IconAudiobookAuthor = IconAudiobookAuthor;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconAudiobookAuthor/index.tsx)
 */
function IconAudiobookAuthor(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M13.5 12.525V6.874l1.5-1.5v8.65h-3.45A5.302 5.302 0 0 0 8 15.382l-.5.447-.5-.447a5.303 5.303 0 0 0-3.55-1.356H0V1.013h3.45c1.516 0 2.917.495 4.05 1.331a6.798 6.798 0 0 1 4.05-1.33h1.446l-1.5 1.5A5.299 5.299 0 0 0 8.25 3.658v9.715a6.797 6.797 0 0 1 3.3-.85h1.95zM6.75 3.659a5.3 5.3 0 0 0-3.3-1.146H1.5v10.012h1.95a6.79 6.79 0 0 1 3.3.85V3.658z\'/><path d=\'m9.66 7.513 1.287-.465c.15-.055.288-.142.402-.256l4.45-4.45a.684.684 0 1 0-.967-.968l-4.451 4.45c-.114.114-.2.251-.255.403L9.66 7.513z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M20 13.432V19h-3c-1.82 0-3.53.487-5 1.338V6.755A7.962 7.962 0 0 1 16.983 5l2-2H17a9.96 9.96 0 0 0-6 2 9.96 9.96 0 0 0-6-2H0v18h5c2.05 0 3.917.77 5.333 2.037l.667.597.667-.597A7.967 7.967 0 0 1 17 21h5v-9.568l-2 2zM10 6.755v13.583A9.957 9.957 0 0 0 5 19H2V5h3a7.96 7.96 0 0 1 5 1.755z\'/><path d=\'m14.293 13.414 1.97-.712c.23-.083.44-.217.615-.39l6.815-6.816a1.048 1.048 0 0 0-1.482-1.482l-6.815 6.815a1.676 1.676 0 0 0-.391.616l-.712 1.97z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconAudiobookAuthor is deprecated and will be archived soon. Use IconAudiobookAuthor instead.
 */
function Experimental__IconAudiobookAuthor(props) {
  return /*#__PURE__*/_react["default"].createElement(IconAudiobookAuthor, props);
}